module.exports = __webpack_public_path__ + "static/media/rioben_logo.f4051192.png";